export default __webpack_public_path__ + "static/media/ribbonProtocol.dd670796.jpeg";